import HighlightHTML from 'components/HighlightHTML/HighlightHTML';
import { formatDateTime } from 'utilities/datesAndTimes';
import { EVENT_TYPE } from './accountHistoryUtilities';

const Event = ({ event, highlight }) => {
  let testId = 'account-history';

  switch (event.__typename) {
    case EVENT_TYPE.AUTOMATED_UPDATE:
      testId = `${testId}-automated-update`;
      break;
    case EVENT_TYPE.COMMUNICATIONS:
      testId = `${testId}-communication`;
      break;
    case EVENT_TYPE.DIGITAL_WALLET_EVENT:
      testId = `${testId}-provisioning`;
      break;
    case EVENT_TYPE.MEMO:
      testId = `${testId}-memo`;
      break;
  }

  return (
    <div className="fs-exclude" data-testid="account-history-event">
      <div>{formatDateTime(event.localizedDate)}</div>
      <HighlightHTML
        data-testid={testId}
        html={event.body}
        textToHighlight={highlight}
      />
    </div>
  );
};

export default Event;
